module.exports = __webpack_public_path__ + "static/media/user_Settings.6e46028c.svg";